import { IS_DEV } from "@/__main__/constants.mjs";
import getData from "@/__main__/get-data.mjs";
import TftStatsModelV2 from "@/data-models/tft-stats-v2.mjs";
import * as API from "@/game-tft/api.mjs";
import { TEMP_MODE } from "@/game-tft/constants.mjs";
import { appLog, devError } from "@/util/dev.mjs";

export default function fetchStatsData({
  patch,
  page,
  tab = null,
  filters,
  set,
  options,
}) {
  const params = new URLSearchParams(filters);
  const isTempMode = params?.get("mode") === TEMP_MODE;

  const endpoint = getEndpoint({
    patch: patch,
    filters,
    page,
    tab,
    isTempMode,
  });

  const location = tab
    ? ["tft", "stats", page, tab, filters, set]
    : ["tft", "stats", page, filters, set];

  return getData(endpoint, TftStatsModelV2(page, tab), location, options).catch(
    (e) => {
      if (!IS_DEV)
        appLog(
          `[TFT V2 STATS FAILED]: ${page}, patch: ${patch}, set: ${set}`,
          e,
        );
      devError(
        `[TFT V2 STATS FAILED]: ${page}, patch: ${patch}, set: ${set}`,
        e,
      );
    },
  );
}

const getEndpoint = ({ patch, filters, page, isTempMode }) => {
  const isEarly = page === "earlycomps";
  const isCompsRelated = page === "comps" || isEarly;

  if (!isTempMode) {
    if (isCompsRelated) {
      return API.getCompsData({
        patch,
        filters,
        type: isEarly ? "early" : "analyzed",
        isTempMode,
      });
    }
    return API.getStatsData({
      patch,
      page,
      filters,
    });
  }

  // Temp mode
  const newFilters = new URLSearchParams(filters);
  if (isCompsRelated) {
    if (isEarly) {
      newFilters?.set("mode", "RANKED");
      return API.getCompsData({
        patch,
        filters: newFilters,
        type: "early",
        isTempMode: false,
      });
    }
    return API.getCompsData({
      patch,
      filters: newFilters,
      type: "analyzed",
      isTempMode,
    });
  }
  return API.getStatsData({
    patch,
    page,
    filters: newFilters,
  });
};
